import React, { Component } from "react";
import {useLocation, useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
  
        return (
            <Component
                {...props}
                router={{ location, navigate }}
            />
        );
    }
    return ComponentWithRouterProp;
}

class PageNotFound extends Component {
    render = () => {
        return (
            <div>
                <div className="stackSpacer"></div>
                <div className="nostackingDiv centerSpacer">
                    <h2>Sorry!</h2>
                    We coudn't find the page you are looking for :(
                    <br/>
                    <br/>
                    <Button variant="outline-danger" onClick={() => this.props.router.navigate(-1)}>Return to Previous Page</Button>{' '}
                </div>
            </div>
        );
    }
}

export default withRouter(PageNotFound)